export const TOP_RIGHT = 'top-right'
export const SUCCESS = 'success'
export const ERROR_ALERT = 'error'
export const WARNING = 'warning'
export const INFO = 'info'
export const DYNAMIC = 'dynamic'
export const LOCAL = 'local'
export const MOBILE_NUMBER_REGEX =
    /^(\+234|234|0)(701|702|703|704|705|706|707|708|709|802|803|804|805|806|807|808|809|810|811|812|813|814|815|816|817|818|819|909|908|901|902|903|904|905|906|907)([0-9]{7})$/
